// Edit the account's email (Users.EmailId — the sign-up email; Alexa reads the
// SAME column, there is no second email) — Me tab on the phone, Profile
// on the desktop. Rules and the reason they exist: core/auth/alexaEmail.js.

import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, Alert,
} from '@mui/material';
import { useApp } from '../../core/state/AppContext';
import { saveAlexaEmail, emailProblem } from '../../core/auth/alexaEmail';
import { showToast } from './toast';
import { FIT_SM } from './fitDialog';

/** The tile/list subtitle for the current value. */
export function alexaEmailCaption(user) {
  const e = String(user?.EmailId || '').trim();
  return e ? `${e} — used for Alexa, must match your Amazon account`
    : 'Not set — Alexa will not find your devices';
}

export default function AlexaEmailDialog({ open, onClose }) {
  const { user, userData, setSession } = useApp();
  const [value, setValue] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) { setValue(String(user?.EmailId || '')); setError(''); setBusy(false); }
  }, [open, user]);

  const save = async () => {
    const p = emailProblem(value);
    if (p) { setError(p); return; }
    setBusy(true);
    const r = await saveAlexaEmail(user?.UserId, value);
    setBusy(false);
    if (!r.ok) { setError(r.message); return; }
    // The session row is what every screen reads — patch it, no re-login.
    if (Array.isArray(userData) && userData.length) {
      setSession([{ ...userData[0], EmailId: r.email }, ...userData.slice(1)]);
    }
    showToast('Email saved', { severity: 'success' });
    onClose();
  };

  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} {...FIT_SM}>
      <DialogTitle>Email</DialogTitle>
      <DialogContent>
        <Alert severity="info" sx={{ mb: 2 }}>
          This is your account email, and Alexa uses it too. It must be the SAME
          email as your Amazon account — the one signed in to the Alexa app
          (usually your Gmail). If it does not match, Alexa finds no devices.
        </Alert>
        <TextField
          autoFocus
          fullWidth
          type="email"
          label="Email"
          value={value}
          onChange={(e) => { setValue(e.target.value); setError(''); }}
          onKeyDown={(e) => e.key === 'Enter' && !busy && save()}
          inputProps={{ inputMode: 'email', autoCapitalize: 'none', autoComplete: 'email', spellCheck: false }}
          error={!!error}
          helperText={error || ' '}
        />
        <Typography variant="caption" color="text.secondary">
          After changing it, ask Alexa to “discover devices”.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>Cancel</Button>
        <Button variant="contained" onClick={save} disabled={busy}>
          {busy ? 'Saving…' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
